// Nomina Theme Global JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Initialize theme functionality
  initializeTheme();
});

function initializeTheme() {
  // Add any global theme functionality here
  console.log('Nomina theme initialized');

  // Add smooth scrolling for anchor links
  initializeSmoothScrolling();

  // Add newsletter form handling
  initializeNewsletter();
}

function initializeSmoothScrolling() {
  const links = document.querySelectorAll('a[href^="#"]');

  links.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });
}

function initializeNewsletter() {
  const newsletterForms = document.querySelectorAll('.nomina-footer__newsletter-form');

  newsletterForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const email = this.querySelector('input[type="email"]').value;
      const button = this.querySelector('button');

      if (email) {
        button.textContent = 'SUBSCRIBED!';
        button.disabled = true;

        setTimeout(() => {
          button.textContent = 'SUBSCRIBE';
          button.disabled = false;
          this.querySelector('input[type="email"]').value = '';
        }, 3000);
      }
    });
  });
}